module.exports = __webpack_public_path__ + "static/img/warning.a0d727f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/warning.png
// module id = RHxi
// module chunks = 1